
import Vue, { PropType } from 'vue'
import {
    CHAT_CHANNELS,
    ChatChannelKey,
    ConnectorAvatarLike,
    findChannelAvatar,
    findChannelAvatarByProvider,
    getChannelFilterColor,
    providerToChannelKey,
} from '@/helpers/gcb2/chatChannels'

type IconSize = 'md' | 'sm' | 'badge'

export default Vue.extend({
    name: 'ChatChannelIcon',
    props: {
        channelKey: {
            type: String as PropType<ChatChannelKey>,
            default: 'maxb',
        },
        provider: {
            type: String,
            default: '',
        },
        size: {
            type: String as PropType<IconSize>,
            default: 'md',
        },
        ordinal: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        displayOrdinal(): string | null {
            if (this.ordinal == null || this.ordinal === '') return null
            const value = String(this.ordinal).trim()
            return value || null
        },
        resolvedKey(): ChatChannelKey {
            return this.resolveChannelKey()
        },
        sizeClass(): string {
            return `chat-channel-icon--${this.size as IconSize}`
        },
        avatar(): ConnectorAvatarLike | null {
            const connectorsAvatars = (this.$store.state.connectorsAvatars ||
                []) as ConnectorAvatarLike[]
            const key = this.resolveChannelKey()

            if (this.provider) {
                return findChannelAvatarByProvider(connectorsAvatars, this.provider)
            }
            return findChannelAvatar(connectorsAvatars, key)
        },
        iconStyle(): Record<string, string> {
            return {
                background: getChannelFilterColor(this.resolveChannelKey()),
            }
        },
        fallbackSymbol(): string {
            const key = this.resolveChannelKey()
            if (key === 'all') return ''
            return CHAT_CHANNELS[key]?.short || '?'
        },
        allIconSize(): number {
            if (this.size === 'badge') return 11
            if (this.size === 'sm') return 9
            return 10
        },
    },
    methods: {
        resolveChannelKey(): ChatChannelKey {
            if (this.provider) {
                return providerToChannelKey(this.provider)
            }
            return (this.channelKey || 'maxb') as ChatChannelKey
        },
    },
})
